import {default as animation} from './modules/_animation';
import {default as header} from './modules/_header';

(function () {
	animation.init();
	header.init();
})();